import functions from '../../functions'
import msgbus from '../../msgBus'


var sqliteHelper = {
    db: {},
    // 连接数据库
    openDatabase() {
        var db = window.sqlitePlugin.openDatabase({ name: 'edsAPP.db', location: 'default' }, function (db) {

            db.transaction(function (tx) {
                // 创建数据表 tx.executeSql('CREATE TABLE IF NOT EXISTS test01 (id, account, name)');
                // accountID 账号ID，例：5f88fed9e13823bd3062e3ca
                // isFlowFile 标识是否是流程文件 1 是，0 不是
                // fileWholeName 文件路径名+文件名
                // fileName 文件名(物理文件存放文件名，若是流程文件则是：tid +fid + flowFileName)
                // flowID 流程ID  add by ydr 2020-10-26
                // flowName 流程名称  add by ydr 2020-10-26
                // flowFileURL 流程文件下载URL
                // flowFileName 流程文件名
                // fileID 文件ID
                // tid 租户ID
                // downloadPer 文件下载百分比
                // flag 预留字段
                tx.executeSql('CREATE TABLE IF NOT EXISTS recent_file (accountID, isFlowFile, createAt, fileWholeName, fileName, flowID, flowName, flowFileURL, flowFileName, encrypted, key, userOID, orgID, clID, fileID, tid, tname, downloadPer,flag)')
            }, function (error) {
                console.log('transaction error: ' + error.message)
            }, function () {
                // console.log('transaction ok')
                functions.sqliteHelper.db = db
                return db
            })

            // 增加flowID字段 // Modify by ydr 2020-10-26
            db.transaction(function (tx) {
                let executeSQL = ' alter table recent_file add column flowID '
                tx.executeSql(executeSQL)
            }, function (error) { // 若重复新建报错不抛
            }, function () {
            })
            // 增加flowName字段 // Modify by ydr 2020-10-26
            db.transaction(function (tx) {
                let executeSQL = ' alter table recent_file add column flowName '
                tx.executeSql(executeSQL)
            }, function (error) { // 若重复新建报错不抛
            }, function () {
            })

        }, function (error) {
            console.log('Open database ERROR: ' + JSON.stringify(error))
        })
    },

    // 判断记录是否存在，若存在，则修改，否则新建
    recordItemToRecent_file(fileInfo) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var query = 'SELECT * FROM recent_file WHERE accountID = ? and isFlowFile = ? and fileName = ? '
                var recentFileSQLValue = []
                recentFileSQLValue.push(msgbus.vm.getAccountID())
                recentFileSQLValue.push(fileInfo.isFlowFile)
                recentFileSQLValue.push(fileInfo.fileName)

                // alert('queryItemFromRecent_file:' + query + ' ' + fileInfo.fileName)

                tx.executeSql(query, recentFileSQLValue, function (tx, resultSet) {
                    // alert('query success:' + resultSet.rows.length)
                    if (resultSet.rows.length == 0) {
                        functions.sqliteHelper.insertItemToRecent_file(fileInfo).then((res) => {
                            console.log('record success insert')
                            resolve(resultSet)
                        })
                    } else {
                        functions.sqliteHelper.updateItemToRecent_file(fileInfo).then((res) => {
                            console.log('record success update')
                            resolve(resultSet)
                        })
                    }
                    console.log('record success')
                },
                    function (tx, error) {
                        console.log('record error: ' + error.message)
                        alert('record error: ' + error.message)
                    })
            }, function (error) {
                console.log('record transaction error: ' + error.message)
            }, function () {
                // console.log('record transaction ok')
            })
        })
    },

    // 新建记录
    insertItemToRecent_file(fileInfo) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var recentFileSQLProp = 'accountID, createAt,'
                var recentFileSQLValueTemp = '?,?,'
                var recentFileSQLValue = [msgbus.vm.getAccountID(), new Date().getTime()]
                for (var key in fileInfo) {
                    recentFileSQLProp += key + ','
                    recentFileSQLValueTemp += '?,'
                    recentFileSQLValue.push(fileInfo[key])
                }
                recentFileSQLProp = recentFileSQLProp.substring(0, recentFileSQLProp.length - 1)
                recentFileSQLValueTemp = recentFileSQLValueTemp.substring(0, recentFileSQLValueTemp.length - 1)

                var query = 'INSERT INTO  recent_file (' + recentFileSQLProp + ') Values (' + recentFileSQLValueTemp + ')'

                // alert('insertItemToRecent_file:' + query)

                tx.executeSql(query, recentFileSQLValue, function (tx, res) {
                    console.log('insert success')
                    // alert('insert success')
                    resolve(res)
                },
                    function (tx, error) {
                        console.log('insert error: ' + error.message)
                        alert('insert error: ' + error.message)
                    })
            }, function (error) {
                console.log('insert transaction error: ' + error.message)
            }, function () {
                // console.log('insert transaction ok')
            })
        })
    },

    // 修改记录
    updateItemToRecent_file(fileInfo) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var recentFileUpdateSQL = 'accountID = ?, createAt = ?,'
                var recentFileUpdateSQLValue = [msgbus.vm.getAccountID(), new Date().getTime()]
                for (var key in fileInfo) {
                    recentFileUpdateSQL += key + ' = ?,'
                    recentFileUpdateSQLValue.push(fileInfo[key])
                }
                recentFileUpdateSQL = recentFileUpdateSQL.substring(0, recentFileUpdateSQL.length - 1)

                var query = 'UPDATE recent_file SET ' + recentFileUpdateSQL + ' WHERE isFlowFile = ? and fileName = ? '
                recentFileUpdateSQLValue.push(fileInfo.isFlowFile)
                recentFileUpdateSQLValue.push(fileInfo.fileName)

                // alert('updateItemToRecent_file:' + query)

                tx.executeSql(query, recentFileUpdateSQLValue, function (tx, res) {
                    console.log('update success')
                    // alert('update success')
                    resolve(res)
                },
                    function (tx, error) {
                        console.log('update error: ' + error.message)
                        alert('update error: ' + error.message)
                    })
            }, function (error) {
                console.log('update transaction error: ' + error.message)
            }, function () {
                // console.log('update transaction ok')
            })
        })
    },

    // 修改记录的下载标记
    updateDownloadPre(fileInfo) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var recentFileUpdateSQL = 'downloadPer = ? '
                var recentFileUpdateSQLValue = [fileInfo.downloadPer]

                var query = 'UPDATE recent_file SET ' + recentFileUpdateSQL + ' WHERE accountID = ? and isFlowFile = ? and fileName = ? '
                recentFileUpdateSQLValue.push(msgbus.vm.getAccountID())
                recentFileUpdateSQLValue.push(fileInfo.isFlowFile)
                recentFileUpdateSQLValue.push(fileInfo.fileName)

                // alert('updateItemToRecent_file:' + query)

                tx.executeSql(query, recentFileUpdateSQLValue, function (tx, res) {
                    console.log('update success')
                    // alert('update success')
                    resolve(res)
                },
                    function (tx, error) {
                        console.log('update error: ' + error.message)
                        alert('update error: ' + error.message)
                    })
            }, function (error) {
                console.log('update transaction error: ' + error.message)
            }, function () {
                // console.log('update transaction ok')
            })
        })
    },

    // 删除记录
    deleteItemFromRecent_file(fileInfo) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var query = 'DELETE FROM recent_file WHERE accountID = ? and isFlowFile = ? and fileName = ? '
                var recentFileUpdateSQLValue = []
                recentFileUpdateSQLValue.push(msgbus.vm.getAccountID())
                recentFileUpdateSQLValue.push(fileInfo.isFlowFile)
                recentFileUpdateSQLValue.push(fileInfo.fileName)

                // alert('deleteItemFromRecent_file:' + query + ' ' + fileInfo.fileName)

                tx.executeSql(query, recentFileUpdateSQLValue, function (tx, res) {
                    console.log('delete success')
                    // alert('delete success')
                    resolve(res)
                },
                    function (tx, error) {
                        console.log('delete error: ' + error.message)
                        alert('delete error: ' + error.message)
                    })
            }, function (error) {
                console.log('delete transaction error: ' + error.message)
            }, function () {
                // console.log('delete transaction ok')
            })
        })
    },

    // 清除记录集
    clearItemsFromRecent_file(files) {
        return new Promise((resolve, reject) => {
            if (files.length == 0) {
                resolve()
            } else {

                functions.sqliteHelper.db.transaction(function (tx) {

                    var query = 'DELETE FROM recent_file WHERE accountID = ? '
                    var recentFileUpdateSQLValue = []
                    recentFileUpdateSQLValue.push(msgbus.vm.getAccountID())

                    let queryFile = ''
                    files.forEach(file => {
                        queryFile += ' ( isFlowFile = ? and fileName = ? ) or '
                        recentFileUpdateSQLValue.push(file.isFlowFile)
                        recentFileUpdateSQLValue.push(file.fileName)
                    })
                    // alert('queryFile.length:' + queryFile.length)
                    // alert('queryFile.lastIndexOf_or:' + queryFile.lastIndexOf('or'))
                    queryFile = queryFile.substring(0, queryFile.lastIndexOf('or'))
                    query += ' and (' + queryFile + ')'

                    // alert('clearItemFromRecent_file:' + query)

                    tx.executeSql(query, recentFileUpdateSQLValue, function (tx, res) {
                        console.log('clear success')
                        // alert('delete success')
                        resolve(res)
                    },
                        function (tx, error) {
                            console.log('clear error: ' + error.message)
                            alert('clear error: ' + error.message)
                        })
                }, function (error) {
                    console.log('clear transaction error: ' + error.message)
                }, function () {
                    // console.log('clear transaction ok')
                })
            }
        })
    },

    // 查询数据
    /* 
    filterInfo:{
        'fileName': '设计',
        'tname': '设计'}
    */
    queryFilesData(isQueryDownload, offSetSize, pageSize, filterInfo) {
        // console.log('调试信息')
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {
                var whereSQL = ' Where accountID = ? '
                var whereSQLValue = [msgbus.vm.getAccountID()]
                var recentFileWhereQL = ''
                if (filterInfo) {
                    for (var key in filterInfo) {
                        recentFileWhereQL += key + ' like ? or '
                        whereSQLValue.push('%' + filterInfo[key] + '%')
                    }
                }
                if (isQueryDownload) {
                    whereSQL += ' and isFlowFile = 1 '
                }
                if (recentFileWhereQL != '') {
                    recentFileWhereQL = recentFileWhereQL.substring(0, recentFileWhereQL.length - 3) // 去掉最后的： 'or ' 
                    whereSQL += ' and (' + recentFileWhereQL + ')'
                }

                var query = 'SELECT * FROM recent_file ' + whereSQL + ' order by createAt desc' + ' limit ' + offSetSize + ',' + pageSize
                // alert('queryFilesData:' + query)

                tx.executeSql(query, whereSQLValue, function (tx, resultSet) {
                    // console.log('query success:' + resultSet.rows.length)
                    // alert('query success:' + resultSet.rows.length)
                    resolve(resultSet)
                },
                    function (tx, error) {
                        console.log('select error: ' + error.message)
                        alert('select error: ' + error.message)
                    })
            }, function (error) {
                console.log('select transaction error: ' + error.message)
            }, function () {
                // console.log('select transaction ok')
            })
        })
    },
    queryFilesDataTotalCount(isQueryDownload, filterInfo) {
        // console.log('调试信息')
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {
                var whereSQL = ' Where accountID = ? '
                var whereSQLValue = [msgbus.vm.getAccountID()]
                var recentFileWhereQL = ''
                if (filterInfo) {
                    for (var key in filterInfo) {
                        recentFileWhereQL += key + ' like ? or '
                        whereSQLValue.push('%' + filterInfo[key] + '%')
                    }
                }
                if (isQueryDownload) {
                    whereSQL += ' and isFlowFile = 1 '
                }
                if (recentFileWhereQL != '') {
                    recentFileWhereQL = recentFileWhereQL.substring(0, recentFileWhereQL.length - 3) // 去掉最后的： 'or ' 
                    whereSQL += ' and (' + recentFileWhereQL + ')'
                }

                var query = 'SELECT count(*) as totalCount FROM recent_file ' + whereSQL
                // alert('queryFilesData:' + query)

                tx.executeSql(query, whereSQLValue, function (tx, resultSet) {
                    // console.log('query success:' + resultSet.rows.length)
                    // alert('query success:' + resultSet.rows.length)
                    resolve(resultSet)
                },
                    function (tx, error) {
                        console.log('select count error: ' + error.message)
                        alert('select count error: ' + error.message)
                    })
            }, function (error) {
                console.log('select count transaction error: ' + error.message)
            }, function () {
                // console.log('select count transaction ok')
            })
        })
    },
    // 查询记录
    queryFile(isFlowFile, fileName) {
        return new Promise((resolve, reject) => {
            functions.sqliteHelper.db.transaction(function (tx) {

                var query = 'SELECT * FROM recent_file WHERE accountID = ? and isFlowFile = ? and fileName = ? '
                var recentFileSQLValue = []
                recentFileSQLValue.push(msgbus.vm.getAccountID())
                recentFileSQLValue.push(isFlowFile)
                recentFileSQLValue.push(fileName)

                // alert('queryItemFromRecent_file:' + query + ' ' + fileName)

                tx.executeSql(query, recentFileSQLValue,
                    function (tx, resultSet) {
                        // alert('query success:' + resultSet.rows.length)
                        console.log('query file success')
                        resolve(resultSet)
                    },
                    function (tx, error) {
                        console.log('query file error: ' + error.message)
                        alert('query file error: ' + error.message)
                    })
            }, function (error) {
                console.log('query file transaction error: ' + error.message)
            }, function () {
                // console.log('query file transaction ok')
            })
        })
    }

}
export default sqliteHelper
